<template>
  <v-main fluid class="pa-0">
    <v-row>
      <v-col cols="12" v-if="model.exibirSalesforce">
        <a
          color="primary"
          target="_blank"
          style="text-align: center; display: block; margin: 2vh; text-decoration:none;"
          :href="`https://thinkcare.lightning.force.com/lightning/r/Quote/${model.cotacaoid}/view`"
        >
          <v-btn color="botao" block>
            <v-icon small left>fas fa-wallet</v-icon>Clique para acompanhar a cotação.
          </v-btn>
        </a>
      </v-col>
      <v-col cols="12" v-else>
        <v-stepper v-model="getcStep" vertical class="elevation-0 pa-1">
          <template v-for="(item, index) in steps">
            <v-stepper-step
              :key="index + '-step'"
              :complete="getcStep > index + 1"
              :step="index + 1"
              color="accent"
              complete-icon="fas fa-check"
              @click="backStep(index)"
              v-if="getcStep == index + 1 || item.respondido"
            >
              <span
                v-if="item.descricao"
                :class="getcStep == index + 1? 'black--text font-weight-bold subtitle-1' : 'body-2'"
                :style="index == 0? 'margin-top: 10px;' : 'margin-top: 0px;'"
              >{{ item.descricao }}</span>
              <span class="caption font-weight-bold" v-if="item.respondido">{{ item.respondido }}</span>
            </v-stepper-step>

            <v-stepper-content
              :step="index + 1"
              :key="index + '-stepcontent'"
              :class="getcStep == index + 1 ? '' : 'd-none'"
            >
              <v-row>
                <!-- regiões -->
                <template v-if="isAvailable(index, 0)">
                  <v-col cols="12" class="p-5">
                    <div class="p-5" style="max-width: 97vw">
                      <p class="text-justify" v-html="getStepInfo('city')"></p>
                    </div>
                    <auto-complete-cidade
                      :loadquote="model"
                      @evento="(_data) => {selecionarCidade(_data, item)}"
                    />
                  </v-col>
                </template>

                <!-- Tipo de Projeto -->
                <template v-if="isAvailable(index, 1)">
                  <study-configuration-select
                    :model="model"
                    @selecionar="() => { selecionarProjeto(item) }"
                    @semdados="() => { backStep(0) }"
                  />
                </template>

                <!-- Distribuição de vidas -->
                <template v-if="index == 2">
                  <v-col cols="12" class="p-5 pb-0">
                    <div class="p-5 pb-0" style="max-width: 97vw">
                      <p class="text-justify" v-html="getStepInfo('dependent-pj')"></p>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div>
                      <v-row
                        elevation="1"
                        class="ma-0 pa-0"
                        :key="'list-item-beneficiario' + ind"
                        v-for="(benecifio, ind) in tabelabeneficiario"
                      >
                        <v-col col="2" class="ma-0 pa-1 right-center">
                          <label
                            style="line-height: 40px;vertical-align: middle"
                            class="font-weight-bold ben-range"
                          >{{benecifio.descricao}}</label>
                        </v-col>
                        <v-col col="3" class="ma-0 pa-1">
                          <v-text-field
                            dense
                            hide-details
                            label="Titulares"
                            placeholder="Quantidade"
                            type="number"
                            min="0"
                            v-model="benecifio.t"
                            outlined
                          />
                        </v-col>
                        <v-col col="3" class="ma-0 pa-1">
                          <v-text-field
                            dense
                            hide-details
                            label="Dependentes"
                            placeholder="Quantidade"
                            type="number"
                            min="0"
                            v-model="benecifio.d"
                            outlined
                          />
                        </v-col>
                        <v-col col="3" class="ma-0 pa-1" v-if="model.exibiAgregado">
                          <v-text-field
                            dense
                            hide-details
                            label="Agregados"
                            placeholder="Quantidade"
                            type="number"
                            min="0"
                            v-model="benecifio.a"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col col="10" class="text-right">
                          <label class="font-weight-bold">Total:</label>
                        </v-col>
                        <v-col col="2">
                          <label class="font-weight-bold">{{getTotalizador()}}</label>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12" class="mt-3">
                    <v-btn color="botao" @click="selecionarDistribuicaoVidas(item)" block>
                      <v-icon small left>fas fa-check</v-icon>Continuar
                    </v-btn>
                  </v-col>
                </template>

                <!-- Conforto -->
                <template v-if="isAvailable(index, 3)">
                  <accomodations-select
                    :model="model"
                    @selecionar="() => { selecionarConforto(item) }"
                    @semdados="() => { backStep(2) }"
                  />
                </template>

                <!--Coparticipação  -->
                <template v-if="isAvailable(index, 4)">
                  <copays-select
                    :model="model"
                    @selecionar="() => { selecionarCoparticipacao(item) }"
                    @semdados="() => { backStep(3) }"
                  />
                </template>

                <!-- Planos -->
                <template v-if="index == 5">
                  <v-col cols="12" v-if="operadoras && operadoras.length > 0">
                    <div class="p-5" style="max-width: 97vw">
                      <p class="text-justify" v-html="getStepInfo('pricePJ', getPrecoInicial())"></p>
                    </div>
                    <br />
                    <v-expansion-panels>
                      <v-expansion-panel
                        v-for="(seg, s) in operadoras"
                        :key="'se'+s"
                        style="min-height: 0px !important;"
                      >
                        <seguradora-item
                          :img="seg.img"
                          :nome="seg.nome"
                          :preco="$util.formatBRL(seg.menorPreco)"
                        />
                        <v-expansion-panel-content>
                          <table style="width: 100%">
                            <plano-item
                              v-for="(pls, p) in seg.planos"
                              :key="'plas'+p"
                              :nome="pls.nome"
                              :segmentacao="pls.segmentacao"
                              :acomodacao="pls.acomodacao"
                              :coparticipacao="pls.coparticipacao ? pls.coparticipacao : null"
                              :preco="pls.preco ? $util.formatBRL(pls.preco) : null"
                              :coparticipacao2="pls.coparticipacao2 ? pls.coparticipacao2 : null"
                              :preco2="pls.preco2 ? $util.formatBRL(pls.preco2): null"
                              :check="pls.check"
                              :regiao="pls.regiao.Name"
                              @evento="selectPlano(pls)"
                            />
                          </table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                  <v-col cols="12" v-if="model.planos && model.planos.length > 0">
                    <v-btn color="botao" block @click="cotacaoSelecionar(item)">
                      <v-icon small left>fas fa-check</v-icon>Continuar
                    </v-btn>
                  </v-col>
                </template>

                <!-- dados pessoais -->
                <template v-if="index == 6">
                  <v-col cols="12">
                    <v-text-field
                      style="margin-bottom: -40px"
                      v-model="model.user.cpfCnpj"
                      label="CNPJ *"
                      placeholder=" "
                      type="text"
                      v-mask="$util.formmasks.cpfcnpj"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      style="margin-bottom: -40px"
                      v-model="model.user.companyName"
                      label="Razão Social *"
                      placeholder=" "
                      type="text"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      style="margin-bottom: -40px"
                      v-model="model.user.name"
                      label="Nome *"
                      placeholder=" "
                      type="text"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      style="margin-bottom: -40px"
                      v-model="model.user.email"
                      label="Email *"
                      placeholder=" "
                      type="email"
                      outlined
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      style="margin-bottom: -40px"
                      v-model="model.user.phonePrefix"
                      label="DDD *"
                      placeholder=" "
                      outlined
                    />
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      style="margin-bottom: -40px"
                      v-model="model.user.phone"
                      label="Telefone *"
                      placeholder=" "
                      type="text"
                      v-mask="$util.formmasks.telefone"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="model.user.emailCC"
                      label="Com cópia para:"
                      placeholder=" "
                      type="email"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="botao" block @click="emitirCotacao()">
                      <small>Emitir Cotação</small>
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
            </v-stepper-content>
          </template>
        </v-stepper>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapState } from "vuex";
import store from "../../store/store";
import StudyConfigurationService from "../../services/salesforce/StudyConfigurationService";
import ProductService from "../../services/salesforce/ProductService";
import InsurancePricingService from "../../services/salesforce/InsurancePricingService";
import SecurityService from "../../services/salesforce/SecurityService";
import MessageInfoService from "../../services/salesforce/MessageInfoService";

// shared
import RegiaoItemList from "../shared/model/regiao.vue";
import SeguradoraItem from "../shared/model/seguradora.vue";
import SeguradoraPlanosItem from "../shared/model/seguradoraPlanos.vue";
import AutoCompleteCidade from "../../components/autocomplete-cidade";

//componentes
import StudyConfiguration from "../../components/study-configuration-select";
import AccomodationsSelect from "../../components/accomodations-select";
import CopaysSelect from "../../components/copays-select";

export default {
  components: {
    "study-configuration-select": StudyConfiguration,
    "accomodations-select": AccomodationsSelect,
    "copays-select": CopaysSelect,

    "regiao-item-list": RegiaoItemList,
    "seguradora-item": SeguradoraItem,
    "plano-item": SeguradoraPlanosItem,
    "auto-complete-cidade": AutoCompleteCidade,
  },
  data() {
    return {
      model: {
        persontype: "PJ",
        selectProjeto: null,
        origin: "Cotador",
        accommodation: [],
        cooparticipacao: [],
        beneficiarios: [],
        simulate: true,
        planos: [],
        exibiAgregado: false,
        user: {
          cpfCnpj: "",
          email: "",
          name: "",
          phone: "",
          phonePrefix: "",
          mobilePhone: "",
          mobilePhonePrefix: "",
          companyName: "",
          emailCC: "",
          userId: "",
        },
        region: {
          label: "",
          value: "",
        },
        cotacaoid: "",
        exibirSalesforce: false,
      },
      cplano: [],
      cregiao: null,
      ctabelaD: 0,
      ctabelaT: 0,
      qtdDependentes: 1,
      cenviarporemail: false,
      tipoDependentes: ["Titular", "Dependente", "Agregado"],
      tabelabeneficiario: [
        {
          descricao: "0-18",
          min: 0,
          max: 18,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "19-23",
          min: 19,
          max: 23,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "24-28",
          min: 24,
          max: 28,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "29-33",
          min: 29,
          max: 33,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "34-38",
          min: 34,
          max: 38,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "39-43",
          min: 39,
          max: 43,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "44-48",
          min: 44,
          max: 48,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "49-53",
          min: 49,
          max: 53,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "54-58",
          min: 54,
          max: 58,
          t: "",
          d: "",
          a: "",
        },
        {
          descricao: "59+",
          min: 59,
          max: 999,
          t: "",
          d: "",
          a: "",
        },
      ],
      regioes: [],
      acomodacoes: [],
      cooparticipacao: [],
      operadoras: [],
      steps: [
        {
          descricao: "",
          respondido: false,
        },
        {
          descricao: "Projetos",
          respondido: false,
        },
        {
          descricao: "Distribuição de vidas",
          respondido: false,
        },
        {
          descricao: "Conforto",
          respondido: false,
        },
        {
          descricao: "Só preciso de mais uma informação.",
          respondido: false,
        },
        {
          descricao: "Cotação",
          respondido: false,
        },
        {
          descricao: "Informe seus dados",
          respondido: false,
        },
      ],
      item: {},
      cStep: 1,
      salesforce: false,
      projetos: [],
    };
  },
  created() {
    this.messageInfo = new MessageInfoService();
    this.model.origin = this.$route.query.origin || "Cotador";
    this.model.type = this.$route.query.type || "HEALTH";
    //this.model.cotacaoid = "0Q06g000000A5dPCAS";
    this.model.exibirSalesforce = false;
    this.salesforce = false;
    switch (this.$route.query.origin) {
      case "salesforce":
        this.salesforce = true;
        break;
    }
  },
  mounted() {
    this._insurancePricingService = new InsurancePricingService();
    this._studyconfiguration = new StudyConfigurationService();
    this._securityService = new SecurityService();
    this._productService = new ProductService();
    // salesforce
    this.loadQuote();
  },
  props: {
    id: null,
    origin: {
      type: String,
    },
    type: {
      type: String,
    },
    personType: {
      type: String,
    },
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    async getCurrentUser() {
      let user = await this._securityService.getCurrentUser("PJ");
      if (user) {
        this.model.user = user;
      }
    },
    async loadQuote() {
      if (localStorage.getItem("current_quote")) {
        this.model = await JSON.parse(localStorage.getItem("current_quote"));
        this.tabelabeneficiario = this.model.beneficiarios;
        this.toogleDialogLoading(true);
      } else {
        this.getCurrentUser();
      }
    },
    isAvailable(index, current) {
      return this.getcStep == index + 1 && index == current;
    },
    getStepInfo(step, params) {
      return this.messageInfo.getExplanation(step, params);
    },
    genericError() {
      store.commit("showmsg", {
        text:
          "Me desculpe, mas no momento, estamos com problemas em nosso servidores, aguarde alguns minutos e tente novamente. Obrigado",
        type: "warning",
      });
    },
    naoDisponivel() {
      store.commit("showmsg", {
        text: this.getStepInfo("nao-disponivel"),
        type: "warning",
      });
    },
    async selecionarCidade(data, item) {
      this.model.region = data;
      item.descricao = "Cidade";
      this.addCstep(item, 1, data.Name);
    },
    selecionarProjeto(item) {
      this.tipoDependentes = ["Dependente"];
      this.model.exibiAgregado = this.model.selectProjeto.Show_Aggregate__c;
      if (this.model.selectProjeto.Show_Aggregate__c) {
        this.tipoDependentes.push("Agregado");
      }

      this.addCstep(item, 1, this.model.selectProjeto.name);
      if (this.model.loadquote) {
        var _item = this.steps[2];
        this.selecionarDistribuicaoVidas(_item);
      }
    },
    selecionarDistribuicaoVidas(item) {
      this.qtdDependentes = 0;
      this.tabelabeneficiario.forEach((element) => {
        this.setDependente(element.d, element.t, element.a);
      });
      // SET BENEFICIARIO
      this.model.beneficiarios = this.tabelabeneficiario;
      if (this.qtdDependentes <= 0) {
        store.commit("showmsg", {
          text: "Você deve preencher a quantidade de vidas",
          type: "error",
        });
      } else {
        if (this.qtdDependentes > this.model.selectProjeto.maximum_lives__c) {
          store.commit("showmsg", {
            text: `Quantidade de vidas não deve ser maior que ${this.model.selectProjeto.maximum_lives__c}`,
            type: "error",
          });
        } else {
          this.addCstep(item, 1, "Total " + this.qtdDependentes + " Vida(s)");
        }
      }
    },
    selecionarConforto(item) {
      let acc = this.model.accommodation.filter((f) => f.check);
      let nomes = acc.map((m) => m.label);

      this.addCstep(item, 1, nomes.join(" ou "));
    },
    selecionarCoparticipacao(item) {
      this.toogleDialogLoading(true);
      let acc = this.model.cooparticipacao.filter((f) => f.check);
      let nomes = acc.map((m) => m.label);
      this.addCstep(item, 1, nomes.join(" ou "));

      setTimeout(() => {
        this.toogleDialogLoading(true);
      }, 100);

      this.operadoras = [];
      this.model.planos = [];
      this.getSimulate(item).then((res) => {
        if (!this.operadoras || this.operadoras.length <= 0) {
          this.naoDisponivel();
        }
      });
    },
    cotacaoSelecionar(item) {
      var permiteAvancar = true; debugger;
      for (let index = 0; index < this.operadoras.length; index++) {
        var operadora = this.operadoras[0];

        // verifica se tem na lista
        if (
          this.model.planos.some(
            (s) =>
              s.seguradora.toLowerCase().trim() ==
              operadora.nome.toLowerCase().trim()
          )
        ) {
          // pega a lista e  verifica se tem mais de 5
          if (
            this.model.planos.filter(
              (fil) =>
                fil.seguradora.toLowerCase().trim() ==
                operadora.nome.toLowerCase().trim()
            ).length > 5
          ) {
            permiteAvancar = false;
          }
        }
      }
      if (permiteAvancar) {
        this.addCstep(item, 1, "OK");
      } else {
        store.commit("showmsg", {
          text: "Permitido apenas 5 planos por operadora.",
          type: "warning",
        });
      }
    },

    planosList() {
      if (this.cenviarporemail) {
        return this.cplano;
      }
      return this.model.planos;
    },
    planosSelectList() {
      return this.cplano;
    },
    funDownload() {
      this.cplano.forEach((el) => {
        window.open(el.urlpdf, "_blank");
      });
    },
    habilitarEnviarPorEmail() {
      this.cenviarporemail = !this.cenviarporemail;
    },
    enviarCotacaoPorEmail() {
      store.commit("showmsg", {
        text: "Cotação enviada por e-mail com sucesso.",
        type: "success",
      });
    },

    isValidCotacao() {
      var bValid = true;
      var msg = "";
      if (!this.model.user.cpfCnpj) {
        bValid = false;
        msg = "Informe o CNPJ";
      }

      if (this.model.user.cpfCnpj.length < 14) {
        bValid = false;
        msg = "Informe o CNPJ válido";
      }

      if (!this.model.user.companyName) {
        bValid = false;
        msg = "Informe a razão social da empresa";
      }

      if (!this.model.user.phonePrefix) {
        bValid = false;
        msg = "Informe o DDD do telefone";
      }

      if (!this.model.user.phone) {
        bValid = false;
        msg = "Informe um telefone";
      }

      if (this.model.user.phone.length < 8) {
        bValid = false;
        msg = "Informe um telefone válido ";
      }

      if (!this.model.user.email) {
        bValid = false;
        msg = "Informe u email";
      }

      if (!this.model.user.email.includes("@")) {
        bValid = false;
        msg = "Informe um e-mail válido";
      }

      if (!bValid) {
        store.commit("showmsg", {
          text: msg,
          type: "warning",
        });
      }

      return bValid;
    },

    emitirCotacao() {
      if (this.isValidCotacao()) {
        this.toogleDialogLoading(true);
        this.model.simulate = false;
        this._insurancePricingService
          .Quote(this.model)
          .then((res) => {
            this.model.cotacaoid = res.data.Id;

            this.model.exibirSalesforce =
              this.$route.query.origin == "salesforce";
            this.salesforce = this.$route.query.origin == "salesforce";

            localStorage.removeItem("current_addfields");
            localStorage.removeItem("current_quote");
            localStorage.removeItem("user_current");

            if (!this.model.exibirSalesforce) {
              this.model.loadquote = false;
              store.commit("showmsg", {
                text:
                  "Sua cotação foi emitida e enviada para o e-mail informado no formulário de Cotação.",
                type: "success",
                redirect: `produto?origin=${this.model.origin}`,
              });
            } else {
              store.commit("showmsg", {
                text: "Cotação emitida com sucesso",
                type: "success",
              });
            }
          })
          .catch((reason) => {
            console.log(JSON.stringify(reason));
            this.genericError();
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
      }
    },

    selectPlano(plano) {
      plano.check = !plano.check;
      if (plano.check) {
        this.model.planos.push(plano);
      } else {
        this.model.planos = this.model.planos.filter(
          (f) => f.nome != plano.nome
        );
      }
    },
    selecFinalPlano(plano, cod) {
      this.cSelectFinalPlano = plano;
      this.addCstep(
        this.steps[cod],
        1,
        `${plano.seguradora}-${plano.nome}-${plano.preco}`
      );
    },
    getPrecoInicial() {
      return this.$util.formatBRL(
        this.operadoras[0].planos.filter((c) => c.preco > 0)[0].preco
      );
    },

    addCstep(item, n, resposta) {
      item.respondido = resposta ? resposta : true;
      this.getcStep = this.getcStep + n;
    },
    addCarrinho(item) {
      this.updateMainSearch("");
      this.updateBadges({ carrinho: this.badges.carrinho + 1 });
      this.$util.link("produtos");
    },
    getTotal(vlD, vlT, vlA) {
      let total = 0;
      if (vlD) total = parseInt(vlD.replace("-", ""));
      if (vlT) total += parseInt(vlT.replace("-", ""));
      if (vlA) total += parseInt(vlA.replace("-", ""));
      return total;
    },
    getTotalizador() {
      let total = 0;
      this.tabelabeneficiario.forEach((element) => {
        total += this.getTotal(element.d, element.t, element.a);
      });
      return total;
    },

    setDependente(vlD, vlT, vlA) {
      this.qtdDependentes += this.getTotal(vlD, vlT, vlA);
    },
    async backStep(n) {
      for (let con = 0; con < this.steps.length; con++) {
        if (n < con) this.steps[con].respondido = null;
      }

      if (this.steps[n].descricao == "Cidade") {
        this.steps[n].descricao = "";
      }
      this.steps[n].respondido = null;
      this.getcStep = n + 1;

      this.model.loadquote = false;
    },
    async getSimulate(item) {
      this.toogleDialogLoading(true);
      this.model.simulate = true;
      this.operadoras = [];
      await this._insurancePricingService
        .Simulate(this.model)
        .then((res) => {
          this.preencheCotacoes(res, item);
        })
        .catch((reason) => {
          store.commit("showmsg", {
            text:
              "Nenhuma cotação disponivel no momento, por favor tente mais tarde.",
            type: "error",
          });
        })
        .finally(() => {
          this.toogleDialogLoading(false);
        });
    },
    async preencheCotacoes(res, item) {
      this.operadoras = await this._insurancePricingService.getQuotePrice(
        res.data
      );

      //
      if (this.operadoras && this.operadoras.length > 0) {
        if (this.model.planosload && this.model.planosload.length > 0) {
          this.model.planosload.forEach((plan) => {
            for (let index = 0; index < this.operadoras.length; index++) {
              this.operadoras[index].planos.forEach((planOperadora) => {
                if (plan.productId === planOperadora.productId) {
                  this.selectPlano(planOperadora);
                  planOperadora.check = true;
                }
              });
            }
          });

          // exibir mensagem
          if (this.model.loadquote) {
            store.commit("showmsg", {
              text: this.getStepInfo("remissao-quote"),
              type: "success",
            });
          }
        }
      }
    },
  },
  computed: {
    getcStep: {
      get: function () {
        return this.cStep;
      },
      set: function (value) {
        this.cStep = value;
      },
    },
  },
};
</script>

<style>
.botao {
  background-color: var(--v-btnprimary-base) !important;
  border-color: var(--v-btnprimary-base) !important;
  color: var(--v-foreground-base) !important;
}
.subtitle-1 {
  padding-bottom: 10px !important;
}
.divmark {
  margin-left: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.cotacao {
  display: flex;
  align-items: center;
}

.cotacao img {
  width: 60px;
  height: 40px;
  border-radius: 50%;
}

.cotacao h3 {
  font-size: 20px;
  margin-left: 10px;
  margin-top: 0px !important;
}
.cotacao h3 span {
  font-size: 12px;
  color: var(--v-foreground-base);
}

.ul-planos {
  list-style: none;
  padding-left: 5px !important;
}

.ul-planos li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-items: center;
}
.ul-planos li strong {
  text-transform: uppercase;
  color: var(--v-foreground-base);
}

.checkmark {
  height: 18px;
  width: 18px;
  border-radius: 50%;
}
/* stepper style */
.v-stepper__content {
  border: 0 !important;
  margin-left: 0 !important;
}
.v-stepper__step--active > span,
.v-stepper__step--inactive > span {
  display: none;
}
.v-stepper {
  background-color: transparent !important;
}
.v-stepper__step,
.v-stepper__content {
  padding-left: 5px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.v-stepper--vertical .v-stepper__content {
  margin-top: -16px !important;
  padding-right: 40px !important;
}

/*  */
.tituloProduto {
  background-color: var(--v-primary);
  position: absolute;
  width: 100%;
  bottom: 0;
}
.ben-range {
  font-size: 14px;
}
input[type="number"]::placeholder {
  font-size: 10px;
  text-align: center;
}

input[type="number"] {
  text-align: center;
}
.pre-text {
  color: darkgray;
  font-size: 10px;
}

.v-expansion-panel-content__wrap {
  padding: 0px 0px 0px 10px !important;
}

.v-expansion-panels {
  z-index: auto !important;
}
</style>
